export class Puesto {
  idTipoPuestoUsuario: number = 3;
  descripcion: string = 'usuario';
  llave: string = 'USUARIO';

  constructor(input?: any) {
    if (input) {
      const props = Object.getOwnPropertyNames(new Puesto());
      const propsInput = Object.keys(input);
      propsInput.forEach((propInput) => {
        if (!props.includes(propInput)) {
          delete input[propInput];
        }
      });
      Object.assign(this, input);
      return this;
    }
  }
}
